import { List, TextField, Datagrid, SelectField, SelectInput, NumberField, SimpleList } from "react-admin";
import { useMediaQuery } from "@mui/material";
import { DoctoralRankingResultStatusChoices } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import DoctoralDateField from "../../Partials/DoctoralDateField";

const DoctoralRankingResultsList = ({ seatId, rankingUrl }) => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const resultsFilters = [
    <SelectInput
      source="status"
      label="Статус"
      choices={DoctoralRankingResultStatusChoices}
      alwaysOn
      emptyText={"Всички"}
    />,
  ];

  return (
    <List
      title={false}
      resource={`${rankingUrl}/results/${seatId}`}
      filters={resultsFilters}
      sx={{ padding: 2 }}
      exporter={false}
    >
      {isMobile ? (
        <SimpleList
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Вх. номер", value: record?.registrationNumber }]} />
              <MobileListRow fields={[{ label: "Име", value: record?.fullName }]} />
            </div>
          )}
          secondaryText={record => (
            <div>
              <MobileListRow
                fields={[
                  {
                    label: "Бал",
                    value: (
                      <NumberField
                        source="score"
                        sortable={false}
                        options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Желание", value: record?.seatPriorityNumber }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Статус",
                    value: (
                      <SelectField
                        source="status"
                        choices={DoctoralRankingResultStatusChoices}
                        sortable={false}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Последна промяна",
                    value: <DoctoralDateField source="updatedOn" showTime sortable={false} />,
                  },
                ]}
              />
            </div>
          )}
        />
      ) : (
        <Datagrid bulkActionButtons={false}>
          <TextField source="registrationNumber" label="Вх. номер" sortable={false} />
          <TextField label="Име" source="fullName" sortable={false} />
          <NumberField
            label="Бал"
            source="score"
            sortable={false}
            options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }}
          />
          <TextField label="Желание" source="seatPriorityNumber" sortable={false} />
          <SelectField label="Статус" source="status" choices={DoctoralRankingResultStatusChoices} sortable={false} />
          <DoctoralDateField label="Последна промяна" source="updatedOn" showTime sortable={false} />
        </Datagrid>
      )}
    </List>
  );
};

export default DoctoralRankingResultsList;
